import React, { Component } from 'react';
import { Layout as OriginLayout } from "@tinper/next-ui";
require('./index.less');

class Layout extends Component {
    render() { 
        return <OriginLayout 
            {...this.props} 			
        />;
    }
}
export default Layout;
